import { AbstractShape } from "../abstract/Shape";
import { Connection } from "../clases/Connection";
import { IConnections } from "../interfaces/Connections";
import { CdkDropList } from '@angular/cdk/drag-drop';

export function deleteConnectionFromList(connection: Connection, list: Connection[]) {
    let index = list.indexOf(connection, 0);
    if (index > -1) {
        list.splice(index, 1);
    }
}

export function deleteConnectionsFromList(connection: IConnections, list: IConnections[]) {
    let index = list.indexOf(connection, 0);
    if (index > -1) {
        list.splice(index, 1);
    }
}

export function deleteItemConnections(item: AbstractShape, list: Connection[]) {
    let conns = list.filter((con) => con.iFrom.id === item.id || con.iTo!.id === item.id);
    for (const connection of conns) {
        deleteConnectionFromList(connection, list);
    }
}

export function filteredResults(list: CdkDropList[], id_list: any[]) {
    if (id_list.length < 1) return list;
    let noDuplicates = list.filter((val: CdkDropList) => !id_list.includes(val));
    return noDuplicates;
}

export const addChildrensToList = (list: CdkDropList[], id_list: any[], mainList: AbstractShape[]) => {
    let filtered = filteredResults(list, id_list);
    id_list = [...filtered, id_list];
    id_list = id_list.filter((item) => item);
    let sorted = organizeList(id_list, mainList);
    id_list = sorted;
    return id_list;
}

export function organizeList(list: CdkDropList[], mainList: AbstractShape[]) {
    const depth = findDepth(mainList, 0);
    let listOfLists: AbstractShape[][] = [];
    for (let index = depth; index >= 0; index--) {
        let res = getByIndex(mainList, index);
        listOfLists = [...listOfLists, res];
    }
    let sortedList: CdkDropList[] = [];
    for (const lst of listOfLists) {
        for (const item of lst) {
            let finded = list.find((dropList) => dropList.id == item.id);
            sortedList = [...sortedList, finded!];
        }
    }
    return sortedList;
}

export function findDepth(list: AbstractShape[], currentDepth: number) {
    for (const item of list) {
        if (item.zIndex > currentDepth) currentDepth = item.zIndex;
        if (item.children.length > 0) currentDepth = findDepth(item.children, currentDepth);
    }
    return currentDepth;
}

export function getByIndex(list: AbstractShape[], index: number, filtered: AbstractShape[] = []) {
    for (const item of list) {
        if (item.zIndex === index) filtered = [...filtered, item];
        if (item.children.length > 0) {
            let ret = getByIndex(item.children, index, filtered);
            let noDuplicates = ret.filter((val: AbstractShape) => !filtered.includes(val));
            filtered = [...filtered, ...noDuplicates];
        };
    }
    return filtered;
}

export function clearFocus(list: AbstractShape[]){
    for (const item of list) {
        item.setFocus(false);
        if (item.children.length > 0) clearFocus(item.children);
    }
}

export function clearConnectionFocus(list: Connection[]){
    for (const conn of list) {
        conn.setFocus(false);
    }
}